import { PageHero } from "../components/PageHero";
import { FaqList } from "../components/FaqList";
import { CTASection } from "../components/CTASection";
import { Seo } from "../components/Seo";

const faqs = [
  { q: "How do I apply for a rental?", a: "Browse our current listings, then submit an online application for the home you're interested in. You'll need identification, proof of income, and references. Most applications are reviewed within 2–3 business days." },
  { q: "How do I pay rent?", a: "Rent is paid securely online through your resident portal. You can set up one-time or automatic recurring payments and view your full payment history anytime." },
  { q: "How do I request maintenance?", a: "Submit a request 24/7 through your resident portal. For emergencies (flooding, no heat, gas smell), call our emergency line immediately and we'll respond right away." },
  { q: "What is your pet policy?", a: "Pet policies vary by property. Where pets are allowed, a pet screening and additional deposit or monthly pet rent may apply. Check the individual listing or ask us." },
  { q: "When is my security deposit returned?", a: "In accordance with Massachusetts law, deposits are returned within 30 days of move-out, less any documented, itemized deductions for damage beyond normal wear and tear." },
  { q: "Can I renew my lease?", a: "Absolutely — we love long-term residents. We'll reach out before your lease ends with renewal options, or you can contact your property manager anytime." },
  { q: "Who do I contact with a question?", a: "Your resident portal has a direct messaging feature, or you can call our office during business hours. We aim to respond the same day." },
];

export default function ResidentFAQ() {
  return (
    <>
      <Seo title="Resident FAQ" description="Answers for current and prospective residents about applications, rent payments, maintenance and lease renewals." />
      <PageHero
        overline="For residents"
        titleLines={["Resident FAQ."]}
        subtitle="Everything you need to know as a resident of a Cummings & Co. managed home."
      />
      <FaqList faqs={faqs} note="Current resident with a question we didn't cover? Reach out and we'll help." />
      <CTASection />
    </>
  );
}
